"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Tooltip = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: block;\n  cursor: pointer;\n  width: 12px;\n  height: 12px;\n  line-height: 0;\n  button {\n    background: none;\n    padding: 0;\n    border: none;\n    cursor: pointer;\n  }\n"])));

var TooltipBox = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  font-family: var(--font-sans);\n  color: var(--color-text-black);\n  text-align: left;\n  max-width: 355px;\n  padding: 11px 15px;\n  background: #fff;\n  .title {\n    font-size: 11px;\n    letter-spacing: 1.8px;\n    line-height: 14px;\n    font-weight: 500;\n    margin-bottom: 20px;\n    text-transform: uppercase;\n  }\n  .paragraph {\n    font-size: 12px;\n    font-weight:  300px;\n    letter-spacing: 0;\n    line-height: 18px;\n  }\n"])));

var _default = {
  Tooltip: Tooltip,
  TooltipBox: TooltipBox
};
exports.default = _default;